export const DIALOG_MAX_HEIGHT = "90vh";
